<template>
  <v-layout wrap justify-center>
    <v-flex xs12 px-5 pb-5 align-self-center>
       <ServerError v-if="ServerError"/>
      <v-layout wrap justify-start>
        <v-flex px-4 xs12 pt-3>
          <h2 style="poppins-bold">{{ type }}</h2>
        </v-flex>
        <v-flex xs12 sm6 md3 xl4 v-for="(item, i) in hardList" :key="i" pa-3>
          <v-card tile>
            <v-layout wrap justify-center pb-2>
              <v-flex xs12>
                <v-img
                  v-if="item.turtleImage"
                  :src="baseURL + item.turtleImage"
                  height="200px"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color=" #FDAC53"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-img
                  v-else
                  src="../../assets/images/no-image.png"
                  height="200px"
                />
              </v-flex>

              <v-flex
                align-self-center
                text-center
                xs12
                :style="{ height: '0px' }"
                text-left
                pa-4
                pt-2
              >
                <router-link class="routerlink" :to="'/seaturtles2/' + item._id">
                  <span 
                    
                    >{{ item.name }}</span
                  >
                 
                </router-link>
              </v-flex>
              <v-flex xs12 pt-4 text-center align-self-center>
                <span style="font-family: poppins-regular">{{
                  item.sci_name
                }}</span>
              </v-flex>
              <v-flex xs12 py-3 px-4 text-center align-self-center>
                <span class="text" style="font-family: poppins-regular"
                  ><b>{{ item.color }}</b></span
                >
              </v-flex>
             
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-if="!hardList" wrap justify-center>
        <v-flex align-self-center text-center py-12>
          <span style="font-family:poppins-bold">No results found!!</span>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  props: ["type"],
  data() {
    return {
      ServerError:false,
      showsnackbar: [],
      snackmessage: [],
      loader: null,
      dialog: true,
      turtleList: [],
      hardList: [],
      softList: [],
      torList: [],
    };
  },
  // created: {
  //   type() {
  //     this.getList();

  //   }
  // },
  watch: {
    type() {
      this.getList();
      // this.runAgain()
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      axios({
        method: "GET",
        url: "turtle/getlist",
      }).then((response) => {
        if (response.data.status) {
          this.turtleList = response.data.data;
          console.log(this.hardList);
          this.runAgain();
        }
      })
      .catch((err) => {
            console.log(err());
            this.ServerError = true;
          });
    },
    runAgain() {
      this.hardList = [];
      for (let i = 0; i < this.turtleList.length; i++) {
        if (this.turtleList[i].type == this.type) {
          this.hardList.push(this.turtleList[i]);
        }
        // if(this.turtleList[i].type == "Soft-Shell Turtle"){
        //   this.softList.push(this.turtleList)
        // }
        // if(this.turtleList[i].type == "Tortoise"){
        //   this.torList.push(this.turtleList)
        // }
      }
    },
  },
};
</script>
<style>
.text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>